<script>
export default {
  name: 'TableHeader',
  props: {
    headerData: { type: Array, required: true },
  },
  data() {
    return {
      sortKey: '',
      sortOrder: '',
    }
  },
  methods: {
    setSortParams(item) {
      if (!item.sortKey) {
        return
      }
      const { sortKey, sortOrder } = item
      if (this.sortKey === sortKey) {
        this.sortOrder =
          this.sortOrder === sortOrder[0] ? sortOrder[1] : sortOrder[0]
      } else {
        this.sortKey = sortKey
        this.sortOrder = sortOrder[0]
      }
      const params = {}
      params[this.sortKey] = this.sortOrder
      this.$emit('set-sort-params', params)
    },
  },
}
</script>

<template>
  <div class="table w-full pb-3 border-b border-gray">
    <div class="table-row">
      <div
        v-for="(item, index) in headerData"
        :key="index"
        :class="item.class"
        @click="() => setSortParams(item)"
      >
        <div :class="item.sortKey && 'flex items-center'">
          {{ item.name }}

          <div v-if="item.sortKey" class="flex flex-col ml-3">
            <svg
              v-if="
                !(item.sortKey === sortKey && sortOrder === item.sortOrder[0])
              "
              xmlns="http://www.w3.org/2000/svg"
              width="13.406"
              height="10"
              viewBox="0 0 13.406 10"
            >
              <g transform="translate(13.406 7.272) rotate(180)">
                <path
                  id="Path_37-2"
                  data-name="Path 37"
                  d="M1089.3,501.408l-6.7-6.7.569-.569,6.134,6.134,6.134-6.134.569.569Z"
                  transform="translate(-1082.593 -494.136)"
                  fill="#00638A"
                />
              </g>
            </svg>
            <svg
              v-if="
                !(item.sortKey === sortKey && sortOrder === item.sortOrder[1])
              "
              xmlns="http://www.w3.org/2000/svg"
              width="13.406"
              height="10"
              viewBox="0 0 13.406 10"
            >
              <g>
                <path
                  id="Path_37"
                  data-name="Path 37"
                  d="M1089.3,501.408l-6.7-6.7.569-.569,6.134,6.134,6.134-6.134.569.569Z"
                  transform="translate(-1082.593 -494.136)"
                  fill="#00638A"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
